<button mat-button color="link" (click)="login()" *ngIf="!isLoggedIn()&&ready()" style="color:white;">
        SIGN IN
</button>
<p *ngIf="isLoggedIn()&&ready()" style="color:white;">
    Welcome, {{getUsername()}}
</p>
<p *ngIf="!ready()" style="color:white;">Loading</p>